import script from "./PersonItemBig.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonItemBig.vue?vue&type=script&setup=true&lang=ts"

import "./PersonItemBig.vue?vue&type=style&index=0&id=72bfe260&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72bfe260"]])

export default __exports__